export default __webpack_public_path__ + "static/media/e-mail.2f9d7cd7.svg";